/**
 * NoctaSync Global Micro-Interactions
 * Premium animations and interactions
 */

(function() {
  'use strict';

  // ========================================
  // 1. SMOOTH SCROLL
  // ========================================
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        const href = this.getAttribute('href');
        
        // Skip if it's just "#" or empty
        if (!href || href === '#') return;
        
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  // ========================================
  // 2. FADE-IN ON SCROLL
  // ========================================
  function initScrollAnimations() {
    // Add fade-in class to sections
    const sections = document.querySelectorAll('section, .sleep-transformation-card, .final-cta-v2-card, .shopify-section');
    
    sections.forEach(section => {
      if (!section.classList.contains('no-animation')) {
        section.classList.add('fade-in-section');
      }
    });

    // Intersection Observer for animations
    const observerOptions = {
      threshold: 0.15,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          // Optional: unobserve after animation (better performance)
          // observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    sections.forEach(section => {
      observer.observe(section);
    });
  }

  // ========================================
  // 3. CARD HOVER EFFECTS
  // ========================================
  function initCardHoverEffects() {
    const cards = document.querySelectorAll('.card, .product-card, [class*="card"]');
    
    cards.forEach(card => {
      card.addEventListener('mouseenter', function() {
        this.style.transition = 'transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.4s ease';
      });
    });
  }

  // ========================================
  // 4. IMAGE HOVER ZOOM
  // ========================================
  function initImageZoom() {
    const images = document.querySelectorAll('.product-card img, .media img, [class*="image"] img');
    
    images.forEach(img => {
      // Wrap in container if not already
      if (!img.parentElement.classList.contains('image-zoom-wrapper')) {
        const wrapper = document.createElement('div');
        wrapper.className = 'image-zoom-wrapper';
        img.parentNode.insertBefore(wrapper, img);
        wrapper.appendChild(img);
      }
    });
  }

  // ========================================
  // 5. BUTTON INTERACTIONS
  // ========================================
  function initButtonEffects() {
    const buttons = document.querySelectorAll('button, .button, a.btn, [class*="cta-button"]');
    
    buttons.forEach(button => {
      // Add ripple effect on click
      button.addEventListener('click', function(e) {
        const ripple = document.createElement('span');
        ripple.classList.add('ripple-effect');
        
        const rect = this.getBoundingClientRect();
        const size = Math.max(rect.width, rect.height);
        const x = e.clientX - rect.left - size / 2;
        const y = e.clientY - rect.top - size / 2;
        
        ripple.style.width = ripple.style.height = size + 'px';
        ripple.style.left = x + 'px';
        ripple.style.top = y + 'px';
        
        this.appendChild(ripple);
        
        setTimeout(() => ripple.remove(), 600);
      });
    });
  }

  // ========================================
  // 6. LOADING STATE
  // ========================================
  function initLoadingState() {
    // Add loaded class to body when page is ready
    window.addEventListener('load', () => {
      document.body.classList.add('page-loaded');
    });
    
    // Fallback if load event already fired
    if (document.readyState === 'complete') {
      document.body.classList.add('page-loaded');
    }
  }

  // ========================================
  // 7. PARALLAX SCROLL (SUBTLE)
  // ========================================
  function initParallax() {
    const parallaxElements = document.querySelectorAll('[data-parallax]');
    
    if (parallaxElements.length === 0) return;
    
    let ticking = false;
    
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrolled = window.pageYOffset;
          
          parallaxElements.forEach(element => {
            const speed = element.dataset.parallax || 0.5;
            const yPos = -(scrolled * speed);
            element.style.transform = `translateY(${yPos}px)`;
          });
          
          ticking = false;
        });
        
        ticking = true;
      }
    });
  }

  // ========================================
  // 8. NAVBAR SCROLL EFFECT
  // ========================================
  function initNavbarScroll() {
    const header = document.querySelector('header, .header, [role="banner"]');
    if (!header) return;
    
    let lastScroll = 0;
    
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      
      if (currentScroll > 100) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
      
      // Hide on scroll down, show on scroll up
      if (currentScroll > lastScroll && currentScroll > 200) {
        header.classList.add('header-hidden');
      } else {
        header.classList.remove('header-hidden');
      }
      
      lastScroll = currentScroll;
    });
  }

  // ========================================
  // 9. PERFORMANCE OPTIMIZATION
  // ========================================
  function optimizePerformance() {
    // Reduce animations on low-end devices
    const isLowEndDevice = navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 4;
    
    if (isLowEndDevice) {
      document.body.classList.add('reduce-animations');
    }
    
    // Pause animations when tab is not visible
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        document.body.classList.add('animations-paused');
      } else {
        document.body.classList.remove('animations-paused');
      }
    });
  }

  // ========================================
  // INIT ALL
  // ========================================
  function init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runInit);
    } else {
      runInit();
    }
  }
  
  function runInit() {
    initLoadingState();
    initSmoothScroll();
    initScrollAnimations();
    initCardHoverEffects();
    initImageZoom();
    initButtonEffects();
    initParallax();
    initNavbarScroll();
    optimizePerformance();
    
    console.log('✨ NoctaSync micro-interactions loaded');
  }

  // Start
  init();

})();